import { render, staticRenderFns } from "./gramlist.vue?vue&type=template&id=4b368e67&scoped=true&"
import script from "./gramlist.vue?vue&type=script&lang=js&"
export * from "./gramlist.vue?vue&type=script&lang=js&"
import style0 from "./gramlist.vue?vue&type=style&index=0&id=4b368e67&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b368e67",
  null
  
)

export default component.exports